import * as React from 'react';
import { useParams, useNavigate } from 'react-router-dom';
import { FormManager, PageTitle, Update, useCacheRecord } from 'gossamer-front-end';
import { LocationTrackingSchedule } from 'cb-model';
import { getListRowLink } from 'gossamer-unified';

export const LocationTrackingScheduleUpdate = (): React.JSX.Element => {
  const params = useParams();
  const navigate = useNavigate();
  const record = useCacheRecord(LocationTrackingSchedule, params.key);
  const handleExit = () => navigate(getListRowLink(LocationTrackingSchedule.listRowLink, params.key));

  return (
    <>
      <PageTitle verb="Update" entity={LocationTrackingSchedule} keyValue={params.key} />
      <FormManager
        compoundUrl="/main/~/location-tracking-schedule-update"
        handleCancel={handleExit}
        handleSuccess={handleExit}
        initialization={{
          main: { type: 'update-single', entity: LocationTrackingSchedule, record },
        }}
      >
        <Update valuesKey="main" entity={LocationTrackingSchedule} />
      </FormManager>
    </>
  );
};
